import { Box, CircularProgress, TextField, Typography } from "@mui/material";

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ElogMeetingContext } from "../context";
import TicketTab from "@pages/Assets/common/TicketTab";

const ReviewTickets = () => {
  const { t } = useTranslation();
  const { form, dispatchElogMeetingDetails, canViewTicket } =
    useContext(ElogMeetingContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        padding: "1rem",
        height: "100%"
      }}>
      {form.elogMeeting === undefined ? (
        <CircularProgress sx={{ alignSelf: "center" }} />
      ) : (
        <>
          <Typography>
            {t(
              "Review the list of tickets that were open during this meeting. Make sure that the issues that should be escalated are kept open and assigned to the right person."
            )}
          </Typography>
          {canViewTicket && (
            <Box
              sx={{
                height: "80%",
                overflowY: "auto",
                padding: "1rem",
                borderRadius: "8px",
              }}
            >
              <TicketTab
                id={`${form.elogMeeting.meetingInstanceId}`}
                type="meeting"
              />
            </Box>
          )}
          <TextField
            fullWidth
            id="elog3rdpartytickets_multiline_textfield"
            label={t("3rd Party Tickets")}
            value={form.details.thirdPartyTickets}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              dispatchElogMeetingDetails({
                thirdPartyTickets: e.target.value,
              })
            }
            slotProps={{
              htmlInput: { maxLength: 255 }
            }}
          />
        </>
      )}
    </Box>
  );
};

export default ReviewTickets;
